import React from "react"

const BackDrop = props => (
  <div className="back-drop" onClick={props.click}></div>
);

export default BackDrop
